<template>
  <el-card header="认领基础信息">
    <auto-parser
      class="auto-url-parser"
      placeholder="请粘贴包含基础字段信息"
      :default-content="noticeParseTemplate"
      :rows="32"
      @submit="handleAutoParse"
    >
      <template #tip>
        <p style="margin-bottom: 10px;">请粘贴包含<b>基础字段</b>信息，务必按下面模板的格式填写，注意使用中文冒号</p>
      </template>
    </auto-parser>

    <el-form
      ref="form"
      :model="baseParams"
      :rules="rules"
      label-width="110px"
      :disabled="!edit"
      inline
    >
      <el-form-item label="音乐名称" prop="musicName">
        <el-input v-model="baseParams.musicName" class="form-field" placeholder="请输入音乐名称"></el-input>
      </el-form-item>
      <el-form-item label="认领时间" prop="claimTime">
        <el-date-picker
          v-model="baseParams.claimTime"
          type="datetime"
          placeholder="请选择认领时间"
          value-format="yyyy-MM-dd"
          class="form-field"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="歌手名" prop="singerName">
        <el-input v-model="baseParams.singerName" class="form-field" placeholder="请输入歌手名"></el-input>
      </el-form-item>
      <el-form-item label="版权(授权)方" prop="claimCompanyName">
        <el-input v-model="baseParams.claimCompanyName" class="form-field" placeholder="请输入版权(授权)方"></el-input>
      </el-form-item>
      <el-form-item label="外显公司" prop="displayCompanyName">
        <el-input v-model="baseParams.displayCompanyName" class="form-field" placeholder="请输入外显公司"></el-input>
      </el-form-item>
      <el-form-item label="授权区域" prop="authArea">
        <el-input v-model="baseParams.authArea" class="form-field" placeholder="请输入授权区域"></el-input>
      </el-form-item>
      <el-form-item label="是否首发" prop="isOnly">
        <el-select v-model="baseParams.isOnly" class="form-field" placeholder="请选择是否首发" @change="baseParams.onlyDuration = 0">
          <el-option
            v-for="(name, id) in switchMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="baseParams.isOnly === 1" label="首发天数" prop="onlyDuration">
        <el-input-number
          v-model="baseParams.onlyDuration"
          :controls="false"
          :min="0"
          :max="30"
          class="small-form-field"
          placeholder="请输入首发天数"
        ></el-input-number> 天
      </el-form-item>
      <el-form-item label="上线平台" prop="onlinePlat">
        <el-select v-model="baseParams.onlinePlat" class="form-field" placeholder="请选择上线平台">
          <el-option
            v-for="(name, id) in onlinePlatformMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合约归属" prop="contract">
        <el-input v-model="baseParams.contract" class="form-field" placeholder="请输入合约归属"></el-input>
      </el-form-item>
      <el-form-item label="是否进付费包">
        <el-select v-model="baseParams.isPay" class="form-field" placeholder="请选择是否进付费包">
          <el-option
            v-for="(name, id) in switchMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否维权">
        <el-select v-model="baseParams.canLegalRights" class="form-field" placeholder="请选择是否维权">
          <el-option
            v-for="(name, id) in switchMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="歌曲数量">
        <el-input-number
          v-model="baseParams.trackCount"
          :controls="false"
          :min="0"
          :max="9999"
          class="small-form-field"
          placeholder="请输入歌曲数量"
        ></el-input-number> 首
      </el-form-item>
      <el-form-item label="伴奏数量">
        <el-input-number
          v-model="baseParams.kTrackCount"
          :controls="false"
          :min="0"
          :max="9999"
          class="small-form-field"
          placeholder="请输入伴奏数量"
        ></el-input-number> 首
      </el-form-item>
      <el-form-item label="视频数量">
        <el-input-number
          v-model="baseParams.mvCount"
          :controls="false"
          :min="0"
          :max="9999"
          class="small-form-field"
          placeholder="请输入视频数量"
        ></el-input-number> 支
      </el-form-item>
      <el-form-item label="授权类型">
        <el-select v-model="baseParams.authType" class="form-field" placeholder="请选择授权类型">
          <el-option
            v-for="(name, id) in authTypeMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人工监控">
        <el-select v-model="baseParams.isMonitor" class="form-field" placeholder="请选择人工监控">
          <el-option
            v-for="(name, id) in switchMap"
            :key="+id"
            :label="name"
            :value="+id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="full" label="备注" prop="remarks">
        <el-input
          v-model="baseParams.remarks"
          type="textarea"
          :rows="3"
          style="width: 100%;"
          placeholder="请输入备注，最多500字"
        ></el-input>
      </el-form-item>
      <el-form-item class="full" label-width="160px" prop="fileList">
        <template #label>
          <span>TME内容信息汇总</span>
          <el-tooltip placement="top">
            <i class="el-icon-info" />
            <template #content>
              具体文件要求，请查看：<a href="https://doc.weixin.qq.com/doc/w3_AWIAKAZhADIaKnrU9wnSU6RBAQYz5?scode=AJEAIQdfAAoDusLESTAGQA6AbQACk" target="_blank">内容汇总信息上传要求</a>
            </template>
          </el-tooltip>
        </template>
        <verify-uploader
          action="/action/upload?type=excel"
          :on-preview="handlePreview"
          :on-remove="handleFileRemove"
          :on-error="handleFileError"
          :on-success="handleFileSuccess"
          :before-upload="handleFileBeforeUpload"
          :file-list="baseParams.fileList"
          :accept="'.' + fileExtType.join(',.')"
        >
          <el-button size="mini" icon="el-icon-upload">上传文件</el-button>
          <a class="download-template-link" href="/file/notice_batch_template.xls">TME内容信息汇总表模板</a>
          <div slot="tip" class="el-upload__tip">支持格式：{{ fileExtType.join(',') }}</div>
        </verify-uploader>
      </el-form-item>
      <el-form-item class="full" label-width="160px" prop="appealRightFileList">
        <template #label>
          <span>权利文件信息</span>
          <el-tooltip placement="top">
            <i class="el-icon-info" />
            <template #content>
              具体文件要求，请查看：<a href="https://doc.weixin.qq.com/doc/w3_AMAAvgZ6ACooVs4k4OATpC9MB3lbi?scode=AJEAIQdfAAouI78nuGAGQA6AbQACk" target="_blank">权利文件上传要求</a>
            </template>
          </el-tooltip>
        </template>
        <el-radio-group v-model="baseParams.rightFileType" style="margin-bottom: 10px;">
          <el-radio v-for="(name, id) in rightFileTypeMap" :key="+id" :label="+id">{{ name }}</el-radio>
        </el-radio-group>
        <el-input
          v-if="baseParams.rightFileType === RIGHT_FILE_TYPE.LINK.code"
          v-model="baseParams.baiduUrl"
          type="textarea"
          :rows="5"
          placeholder="请输入网盘链接+密码"
        ></el-input>
        <verify-uploader
          v-else
          class="custom-uploader"
          action="/action/upload?type=license"
          drag
          multiple
          :on-preview="handlePreview"
          :on-remove="handleRightFileRemove"
          :on-error="handleRightFileError"
          :on-success="handleRightFileSuccess"
          :before-upload="handleRightFileBeforeUpload"
          :file-list="baseParams.appealRightFileList"
          :accept="'.' + rightFileExtType.join(',.')"
        >
          <div slot="trigger" class="upload-trigger">
            <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
            <p>点击或将文件拖拽上传权利文件</p>
            <span>支持格式：{{ rightFileExtType.join(',') }}</span>
          </div>
        </verify-uploader>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { validateFileExt } from '@/utils/validate'
import { VerifyUploader } from '@/components'
import { CpNotice } from '@/models/Complaint'
import {
  switchMap,
  fileExtType,
  rightFileExtType,
  onlinePlatformMap,
  authTypeMap,
  RIGHT_FILE_TYPE,
  rightFileTypeMap,
  noticeParseTemplate,
  parseTemplate
} from './const'

import AutoParser from './AutoParser'

export default {
  name: 'NoticeBaseForm',
  components: {
    AutoParser,
    VerifyUploader,
  },
  props: {
    baseParams: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const wordLimitValidator = (label, len, required = true) => {
      return (rule, value, callback) => {
        if (required && !value) {
          return callback(new Error(`请输入${label}`))
        } else if (value && (value.length > len)) {
          callback(new Error(`${label}输入字符超出${len}长度限制`))
        } else {
          callback()
        }
      }
    }

    const rightFileValidator = (rule, value, callback) => {
      if (value.length === 0 && !this.baseParams.baiduUrl) {
        callback(new Error('请上传权利文件或填写网盘链接+密码'))
      } else {
        callback()
      }
    }
    return {
      switchMap,
      fileExtType,
      rightFileExtType,
      onlinePlatformMap,
      authTypeMap,
      RIGHT_FILE_TYPE,
      rightFileTypeMap,
      noticeParseTemplate,

      rules: {
        musicName: [{ required: true, validator: wordLimitValidator('音乐名称', 25), trigger: 'blur' }],
        claimTime: [{ required: true, message: '请选择认领时间', trigger: 'change' }],
        singerName: [{ required: true, validator: wordLimitValidator('歌手名', 10), trigger: 'blur' }],
        claimCompanyName: [{ required: true, validator: wordLimitValidator('版权(授权)方', 25), trigger: 'blur' }],
        displayCompanyName: [{ validator: wordLimitValidator('外显公司', 25, false), trigger: 'blur' }],
        authArea: [{ required: true, validator: wordLimitValidator('授权区域', 25), trigger: 'blur' }],
        isOnly: [{ required: true, message: '请选择是否首发', trigger: 'change' }],
        onlinePlat: [{ required: true, message: '请选择上线平台', trigger: 'change' }],
        isPay: [{ required: true, message: '请选择是否进付费包', trigger: 'change' }],
        canLegalRights: [{ required: true, message: '请选择是否维权', trigger: 'change' }],
        authType: [{ message: '请选择授权类型', trigger: 'change' }],
        isMonitor: [{ message: '请选择人工监控', trigger: 'change' }],
        contract: [{ required: true, validator: wordLimitValidator('合约归属', 50), trigger: 'blur' }],
        remarks: [{ validator: wordLimitValidator('备注', 500, false), trigger: 'blur' }],
        fileList: [{ required: true, type: 'array', message: '请上传TME内容信息汇总文件', trigger: 'change' }],
        appealRightFileList: [{ required: true, type: 'array', validator: rightFileValidator, trigger: 'change' }],
      },
    }
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, error) => {
          if (valid) {
            resolve()
          } else {
            reject(Object.values(error)[0][0])
          }
        })
      })
    },

    async handleAutoParse(data) {
      try {
        const parsedData = parseTemplate(data)
        this.$emit('update:baseParams', new CpNotice({
          ...this.baseParams,
          ...parsedData
        }))
      } catch (error) {
        this.$alert(error.message, '解析失败', {
          error,
          type: 'error',
        })
      }
    },

    handleFileRemove(file, fileList) {
      this.baseParams.fileList = fileList
    },
    handleFileError(err, file, fileList) {
      this.baseParams.fileList = fileList
      this.$message.error('文件上传失败: ' + err.message)
    },
    handleFileSuccess(resp, file, fileList) {
      this.handleSuccess(resp, file)
      this.baseParams.fileList = fileList.slice(-1)
    },
    handleFileBeforeUpload(file) {
      return this.handleBeforeUpload(fileExtType, file, this.baseParams.fileList)
    },

    handleRightFileRemove(file, fileList) {
      this.baseParams.appealRightFileList = fileList
    },
    handleRightFileError(err, file, fileList) {
      this.baseParams.appealRightFileList = fileList
      this.$message.error('授权文件上传失败: ' + err.message)
    },
    handleRightFileSuccess(resp, file, fileList) {
      this.handleSuccess(resp, file)
      this.baseParams.appealRightFileList = fileList
    },
    handleRightFileBeforeUpload(file) {
      return this.handleBeforeUpload(rightFileExtType, file, this.baseParams.appealRightFileList)
    },

    handlePreview(file) {
      open(file.url, '_blank')
    },
    handleSuccess(resp, file) {
      file.fileUrl = file.url = resp.data.url
      file.filePath = file.path = resp.data.file_id
      file.fileName = file.name
      file.md5 = resp.data.md5
    },
    handleBeforeUpload(extType, file, fileList) {
      if (!validateFileExt(extType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      const sameFile = fileList.find(v => v.md5 === file.md5)
      if (sameFile) {
        this.$message.warning(`文件已存在，请检查【${file.name}】和【${sameFile.name}】`)
        return Promise.reject()
      }

      return Promise.resolve()
    },
  }
}
</script>

<style lang="scss" scoped>
.auto-url-parser {
  margin: 0;
  margin-left: -24px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: bold;
}

.small-form-field {
  width: 190px;
}

.form-field {
  width: 210px;
}
.long-form-field {
  width: 380px;
}

::v-deep {
    .el-form {
    .full.el-form-item {
      display: flex;
      margin-bottom: 0;
      padding-bottom: 18px;
      .el-form-item__content {
        flex: 1;
      }
    }
  }

  .upload-trigger {
      margin-top: 16px;

      .upload-icon {
        width: 42px;
        height: 50px;
      }

      p {
        margin: 10px 0;
      }
    }

  .download-template-link {
    font-size: 12px;
    vertical-align: bottom;
    margin-left: 30px;
    text-decoration: underline;
  }

  .custom-uploader {
    .el-upload.el-upload--text {
      width: 500px;
      background: #F3F3F3;
      border: 1px dashed #4071FF;
      border-radius: 4px;
      padding: 10px;
    }

    .el-upload-dragger {
      background-color: unset;
      border: none;
      width: 100%;
      min-height: 180px;
      height: 100%;
    }
  }
}
</style>
